import { createSlice } from '@reduxjs/toolkit';

export const profileSlice = createSlice({
  name: 'profile',
  initialState: {
    user: null,
    isSidebar: false,
    loader: false, // Stores profile data (name, email, etc.)
  },
  reducers: {
    setProfile(state, action) {
      state.user = action.payload; // Set profile data
    },
    clearProfile(state) {
      state.user = null; // Clear profile data
    },
    setSidebar(state) {
      state.isSidebar = !state.isSidebar;
    },
    closeAccessLoader: (state, action) => {
      state.loader = action.payload;
    },
  },
});

export const { setProfile, clearProfile, setSidebar, closeAccessLoader } = profileSlice.actions;
export default profileSlice.reducer;
